import { render } from "./ProductsImporter.vue?vue&type=template&id=b90cd61e"
import script from "./ProductsImporter.vue?vue&type=script&lang=js"
export * from "./ProductsImporter.vue?vue&type=script&lang=js"

import "./ProductsImporter.vue?vue&type=style&index=0&id=b90cd61e&lang=css"
script.render = render

export default script